export enum NotificationErrTypes {
  accountDeactive = "accountDeactive",
  userNotFound = "userNotFound",
  accountLocked = "accountLocked",
  userNotFoundWithSignUp = "userNotFoundWithSignUp",
  userNotRegister = "userNotRegister",
  defaultTenantNotFound = "defaultTenantNotFound",
  passwordWrong = "passwordWrong",
  saveUserFail = "saveUserFail",
  createPasswordFail = "createPasswordFail",
  someThingWrong = "someThingWrong",
  statusChangedFail = "statusChangedFail",
  defaultTenantFail = "defaultTenantFail",
  domainDeleteFail = "domainDeleteFail",
  domainAddFail = "domainAddFail",
  tenanatUpdateFail = "tenanatUpdateFail",
  userLockedWithThreeWrongAttempts = "userLockedWithThreeWrongAttempts",
  reSendLinkFail = "reSendLinkFail",
  confirmUserFail = "confirmUserFail",
  passwordNotSet = "passwordNotSet",
  accountNotVerified = "accountNotVerified",
  sureToDeleteRecord = "sureToDeleteRecord",
  departmentAddFail = "departmentAddFail",
  departmentDeleteFail = "departmentDeleteFail",
  departmentEditFail = "departmentEditFail",
  mfaUpdatedFail = "mfaUpdatedFail",
  inactiveUserToDefault = "inactiveUserToDefault",
  defaultUserToinactive = "defaultUserToinactive",
  resetPasswordFail = "resetPasswordFail",
  userExist = "userExist",
  invalidParameterException = "invalidParameterException",
  roleDeleteFail = "roleDeleteFail",
  roleAlreadyUsed = "roleAlreadyUsed",
  departmentExist = "departmentExist",
  recaptchaVerificationFail = "recaptchaVerificationFail",
  recaptchaExpired = "recaptchaExpired",
  forgotPasswordLinkFail = "forgotPasswordLinkFail",
  nonSSOToForgotPassword = "nonSSOToForgotPassword",
  forgotPasswordEmailNotFound = "forgotPasswordEmailNotFound",
}

export type INotificationError = {
  [key in NotificationErrTypes]: string;
};

export enum NotificationSuccessTypes {
  logginSuccess = "logginSuccess",
  userCreated = "userCreated",
  createPasswordSuccess = "createPasswordSuccess",
  tenanatCreatedSuccess = "tenanatCreatedSuccess",
  statusChangedSuccess = "statusChangedSuccess",
  defaultTenantSuccess = "defaultTenantSuccess",
  domainDeleteSuccess = "domainDeleteSuccess",
  domainAddSuccess = "domainAddSuccess",
  tenanatUpdateSuccess = "tenanatUpdateSuccess",
  reSendLinkSuccess = "reSendLinkSuccess",
  departmentAddSuccess = "departmentAddSuccess",
  departmentDeleteSuccess = "departmentDeleteSuccess",
  departmentEditSuccess = "departmentEditSuccess",
  roleSaveSuccess = "roleSaveSuccess",
  roleUpdateSuccess = "roleUpdateSuccess",
  roleDeleteSuccess = "roleDeleteSuccess",
  mfaUpdatedSuccess = "mfaUpdatedSuccess",
  deactiveStatusChangedSuccess = "deactiveStatusChangedSuccess",
  activeStatusChangedSuccess = "activeStatusChangedSuccess",
  lockStatusChangedSuccess = "lockStatusChangedSuccess",
  unlockStatusChangedSuccess = "unlockStatusChangedSuccess",
  deleteStatusChangedSuccess = "deleteStatusChangedSuccess",
  undeleteStatusChangedSuccess = "undeleteStatusChangedSuccess",
  resetPasswordSuccess = "resetPasswordSuccess",
  roleActiveSuccess = "roleActiveSuccess",
  roleDeactiveSuccess = "roleDeactiveSuccess",
  forgotPasswordLinkSuccess = "forgotPasswordLinkSuccess",
  accountRegisteredWithSSO = "accountRegisteredWithSSO"
}

export type INotificationSuccess = {
  [key in NotificationSuccessTypes]: string;
};

const MESSAGES = {
  SIGNUP: {
    ERROR: {
      FIRST_NAME: {
        EMPTY: 'Please enter first name',
        INVALID: 'Please enter valid first name'
      },
      LAST_NAME: {
        EMPTY: 'Please enter last name',
        INVALID: 'Please enter valid last name'
      },
      EMAIL: {
        EMPTY: 'Please enter email',
        INVALID: 'Please enter valid email'
      },
      PASSWORD: {
        EMPTY: 'Please enter password',
        INVALID: 'Please enter valid password'
      },
      CPASSWORD: {
        EMPTY: 'Please enter confirm password',
        INVALID: 'Please enter valid confirm password'
      }
    },
  },
  FORGOT: {
    ERROR: {
      EMAIL: {
        EMPTY: 'Please enter email',
        INVALID: 'Please enter valid email'
      }
    },
  },
  TENANT: {
    ERROR: {
      FIRST_NAME: {
        EMPTY: 'Please enter First name',
        INVALID: 'Please enter valid first name'
      },
      LAST_NAME: {
        EMPTY: 'Please enter Last name',
        INVALID: 'Please enter valid last name'
      },
      MIDDELE_NAME: {
        EMPTY: 'Please enter middle name',
        INVALID: 'Please enter valid middle name'
      },

      TENANT_NAME: {
        EMPTY: 'Please enter tenant name',
        INVALID: 'Please enter valid tenant name'
      },
      DOMAIN: {
        EMPTY: 'Please enter domain name',
        INVALID: 'Please enter valid domain name'
      },
      EMAIL: {
        EMPTY: 'Please enter email',
        INVALID: 'Please enter valid email',
        INVALID_FREE: 'Please enter valid work email',
        INVALID_REGISTERED: 'This email address is already registered'
      },
      PASSWORD: {
        INVALID: "Password length should be at least 8"
      },
      USER_NAME: {
        EMPTY: 'Please enter username',
        INVALID: 'Please enter valid username'
      },
      DISPLAY_NAME: {
        EMPTY: 'Please enter display name',
        INVALID: 'Please enter valid display name'
      },
      ROLE_NAME: {
        EMPTY: 'Please enter role name',
        INVALID: 'Please enter valid role name'
      }
    }
  },
  ROLE: {
    ERROR: {
      ROLE_NAME: {
        EMPTY: 'Please enter role name',
        INVALID: 'Please enter valid role name'
      },
      ROLE_ALIAS: {
        EMPTY: 'Please enter Last name',
        INVALID: 'Please enter valid last name'
      },
      ROLE_DESC: {
        EMPTY: 'Please enter middle name',
        INVALID: 'Please enter valid middle name'
      }
    },
  },
  DEPARTMENT: {
    ERROR: {
      DEPARTMENT_ALIAS: {
        EMPTY: 'Please enter department alias',
      },
      DEPARTMENT_NAME: {
        EMPTY: 'Please enter department name',
      }
    }
  },
  NOTIFICATIONS: {
    ERROR: {
      accountDeactive: "Your subscription or trial is now over please contact your customer sales rep to talk about your subscription.",
      userNotFound: "User does not found",
      accountLocked: "There seems to be an issue with your account. Please contact Customer Support at <a href='mailto:support@getimmersion.com'>support@getimmersion.com</a> or reset your password.",
      userNotFoundWithSignUp: "Login does not exist. If you require assistance please chat with us below or contact us at <a href='mailto:support@getimmersion.com'>support@getimmersion.com</a>",
      userNotRegister: "Sorry, we could not register this account. If you require assistance please chat with us below or contact us at <a href='mailto:support@getimmersion.com'>support@getimmersion.com</a>",
      defaultTenantNotFound: "Problem while get default tenant data",
      passwordWrong: "Sorry, you have entered an incorrect password. Please click <a href='/user/reset-password' />here</a> to reset your password. If you require assistance please chat with us below or contact us at <a href='mailto:support@getimmersion.com'>support@getimmersion.com</a>",
      saveUserFail: "Sorry, Problem occurred while save user in database",
      createPasswordFail: "Sorry, Problem occurred while creating your password",
      someThingWrong: "Sorry, Something Went Wrong!",
      statusChangedFail: "Problem occurred during change status",
      defaultTenantFail: "Problem occurred while changing Default Tenant",
      domainDeleteFail: "Problem occurred while deleting domain",
      domainAddFail: "Problem occurred while adding domain",
      tenanatUpdateFail: "Problem occurred while updating tenant",
      userLockedWithThreeWrongAttempts: "Three wrong attempts to login, Please click <a href='/user/reset-password' />here</a> to reset your password. If you require assistance please chat with us below or contact us at <a href='mailto:support@getimmersion.com'>support@getimmersion.com</a>",
      reSendLinkFail: "Problem occurred while resend link",
      confirmUserFail: "Please enter an acceptable password",
      passwordNotSet: "Sorry, you have not created password for your account, Please create password first. If you require assistance please chat with us below or contact us at <a href='mailto:support@getimmersion.com'>support@getimmersion.com</a>",
      accountNotVerified: `Sorry, you must verify account.  Please click the link in the verification email.  <span><b>Click here</b></span> to resend the verification email. If you require assistance please chat with us below or contact us at <a href='mailto:support@getimmersion.com'>support@getimmersion.com</a>`,
      sureToDeleteRecord: "Are you sure you want to delete this record?",
      departmentAddFail: "Problem occurred while adding department",
      departmentDeleteFail: "Problem occurred while deleting department",
      departmentEditFail: "Problem occurred while editing department",
      mfaUpdatedFail: "Problem occurred while update mfa settings",
      inactiveUserToDefault: "Tenant is inactive so you can not set to default. Please activate this tenant first.",
      defaultUserToinactive: "Tenant is marked as default so you can not make it inactive. Please change it from the default tenant first",
      resetPasswordFail: "Problem occurred while reseting password",
      userExist: "Hmmm... Seems like there is a problem. You could try resetting your password or double check your email address above.",
      invalidParameterException: "Please update mobile number first, then try again",
      roleDeleteFail: "Problem occurred while deleting role",
      roleAlreadyUsed: "This role is assigned to a user, so you can't delete this role.",
      departmentExist: "This department already exists in system, please try with another.",
      recaptchaVerificationFail: "Recaptcha verification fail, please try again",
      recaptchaExpired: "Recaptcha is expired, please try again",
      forgotPasswordLinkFail: "Problem while sending reset password link",
      nonSSOToForgotPassword: "Sorry, you can not reset password for an account which is registered with Google or Apple.",
      forgotPasswordEmailNotFound: "Your email address is not registered in the system",
      uploadProfilePictureFail: "Problem occurred while upload profile picture.",
      sendEmailFail: "Problem occurred while sending email, please try again",
      passwordNotCreated: "Sorry, you have not created a password for your account so you can't reset it.",
      endDateShouldGrater:"End date time should be greater than the start time",
      dateTimeShouldNotLessCurrent:"Date time should not be less than the current date time",
      accountRegisteredWithSSO:"You previously signed up with Google or Apple, please go back and click continue with Google or continue with Apple to sign in.",
      csvFileValidation:"Hey! it seems like your file is either not a CSV file and has the incorrect format for upload. Please double-check your file before trying to re-upload",
      blankCsvError:"There is no data to export please check your file again."
    },
    SUCCESS: {
      logginSuccess: "Login Successfully",
      userCreated: "User is created successfully",
      createPasswordSuccess: "Password is created successfully",
      tenanatCreatedSuccess: "Tenant is created successfully",
      statusChangedSuccess: "Tenant status is changed successfully",
      defaultTenantSuccess: "Default Tenant is changed successfully",
      domainDeleteSuccess: "Domain is deleted successfully",
      domainAddSuccess: "Domain is added successfully",
      tenanatUpdateSuccess: "Tenant is updated successfully",
      reSendLinkSuccess: "Link is sent successfully",
      departmentAddSuccess: "Department is added successfully",
      departmentDeleteSuccess: "Domain is deleted successfully",
      departmentEditSuccess: "Domain is updated successfully",
      roleSaveSuccess: "Role is saved successfully",
      roleUpdateSuccess: "Role is Update successfully",
      roleDeleteSuccess: "Role is Deleted successfully",
      mfaUpdatedSuccess: "MfA is updated successfully",
      deactiveStatusChangedSuccess: "User is deactivated successfully",
      activeStatusChangedSuccess: "User is activated successfully",
      lockStatusChangedSuccess: "User is locked successfully",
      unlockStatusChangedSuccess: "User is unlocked successfully",
      deleteStatusChangedSuccess: "User is deleted successfully",
      undeleteStatusChangedSuccess: "User is undeleted successfully",
      resetPasswordSuccess: "Password is changed successfully",
      roleActiveSuccess: "Role active successfully",
      roleDeactiveSuccess: "Role deactive successfully",
      forgotPasswordLinkSuccess: "Reset password link send in your mail",
      EDITEXPERIENCE: 'Experience is updated successfully',
      NEWEXPERIENCE: 'New experience is created successfully',
      CANCELEXPERIENCE: 'Experience is cancelled successfully',
      DELETEEXPERIENCE: 'Experience is deleted successfully',
      COMPLETEEXPERIENCE: 'Experience is completed successfully',
      ADDROLESUCCESS: 'Role created successfully',
      UPDATEROLESUCCESS: 'Role updated successfully',
      UPDATEROLESTATUSSUCCESS: 'Role status updated successfully',
      DELETEROLESUCCESS: 'Role deleted successfully',
    }
  },
}

export default MESSAGES;
